<template>
  <div id="app"></div>
  <router-view></router-view>
</template>

<script>
export default {};
</script>

<style>
* {
  font-family: "Lato", sans-serif;
  margin: 0;
  padding: 0;
}
</style>
